// extracted by mini-css-extract-plugin
module.exports = {"changeItem":"changes_changeItem__3nNZ7","changeBefore":"changes_changeBefore__3sHRe","changeArrow":"changes_changeArrow__HwESQ"};